import React, { useState } from 'react';
import {
  CheckGroupCardSociogram,
  MultipleSelectCardSociogram,
  RadioGroupCardSociogram,
} from '@BUP/components';
import { findAnswerByHasExternalList } from '@BUP/services/BraveUp/Sociogram';
import { useAuth } from '@BUP/hooks';
import styles from './question-element.module.css';

const getSpecificFormItem = (props) => {
  const { user } = useAuth();

  const {
    question,
    onChangeQuestionResponse,
    classMate,
    classMates,
    handleChangeMultipleSelect,
    hasDependency,
    name,
    hasMe,
  } = props;

  return {
    radio: (
      <RadioGroupCardSociogram
        question={question}
        name={name}
        required={question?.isRequired}
        questionText={question?.question_textId?.name}
        options={question?.question_textId?.answers}
        hasIcon={question?.question_textId?.hasIcon}
        onChange={onChangeQuestionResponse}
        classMate={classMate || null}
        hasDependency={hasDependency}
      />
    ),
    select: (
      <MultipleSelectCardSociogram
        name={name}
        question={question}
        required={question?.isRequired}
        questionText={question?.question_textId?.name}
        onChange={handleChangeMultipleSelect}
        hasMe={hasMe}
        classMatesOptions={
          hasMe
            ? classMates
            : classMates?.filter(
                (classMate) => classMate?.enrollmentId !== user?.enrollmentId
              )
        }
        answersOptions={question?.question_textId?.answers}
        hasDependency={hasDependency}
        hasCompanionNames={question?.question_textId?.hasCompanionNames}
      />
    ),
    check: (
      <CheckGroupCardSociogram
        question={question}
        name={name}
        required={question?.isRequired}
        questionText={question?.question_textId?.name}
        options={question?.question_textId?.answers}
        hasIcon={question?.question_textId?.hasIcon}
        onChange={onChangeQuestionResponse}
        classMate={classMate || null}
        hasDependency={hasDependency}
        sm={24}
        md={12}
        lg={8}
      />
    ),
  };
};

const QuestionElement = ({ type, ...rest }) => {
  const { question, onChangeQuestionResponse } = rest;
  const [selectedClassMates, setSelectedClassMates] = useState([]);
  const hasDependency = !!(
    question?.dependencies && question?.dependencies.length
  );
  const dependencies = question?.dependencies || [];

  // Maneja comportamiento de MultipleSelectCardSociogram
  const handleChangeMultipleSelect = (elementName, question, options) => {
    const newSelectedClassMates = options.map((user) => ({
      name: user?.children,
      enrollmentId: user.value,
    }));
    const answer = findAnswerByHasExternalList(
      question?.question_textId?.answers,
      !!newSelectedClassMates.length
    );
    // Maneja comportamiendo de CheckGroupCardSociogram y RadioGroupCardSociogram
    onChangeQuestionResponse(
      elementName,
      question,
      answer?.id,
      newSelectedClassMates
    );
    setSelectedClassMates(newSelectedClassMates);
  };

  return (
    <div
      className={styles.container}
      style={{
        margin: '35px 0',
        boxShadow: '8px 10px 30px -15px rgb(172, 170, 170)',
        border: hasDependency ? '1px solid #f0f0f0' : 'none',
      }}
      hasMe={question?.question_textId?.hasMe}
    >
      {
        getSpecificFormItem({
          ...rest,
          question,
          handleChangeMultipleSelect,
          hasDependency,
          dependencies,
          name: `question-${question?.question_textId?.id}`,
        })[type]
      }
      {hasDependency && selectedClassMates && selectedClassMates.length
        ? selectedClassMates.map((classMate) => (
            <div
              key={`question-${question?.question_textId?.id}-classmate-${classMate?.enrollmentId}`}
              style={{ padding: '0 20px 20px 20px' }}
            >
              {dependencies && dependencies.length
                ? dependencies.map((subQuestion) => (
                    <div
                      key={`question-${question?.question_textId?.id}-subQuestion-${subQuestion?.question_textId?.id}-classmate-${classMate?.enrollmentId}`}
                    >
                      {
                        getSpecificFormItem({
                          ...rest,
                          question: subQuestion,
                          hasDependency,
                          dependencies,
                          classMate,
                          name: `dependency-${question?.question_textId?.id}-question-${subQuestion?.question_textId?.id}-classmate-${classMate?.enrollmentId}`,
                        })[subQuestion?.question_textId?.type]
                      }
                    </div>
                  ))
                : null}
            </div>
          ))
        : null}
    </div>
  );
};

export default QuestionElement;
